import { render, staticRenderFns } from "./modalSalarioFamiliaBase.vue?vue&type=template&id=05c71a11&scoped=true&"
import script from "./modalSalarioFamiliaBase.vue?vue&type=script&lang=js&"
export * from "./modalSalarioFamiliaBase.vue?vue&type=script&lang=js&"
import style0 from "./modalSalarioFamiliaBase.vue?vue&type=style&index=0&id=05c71a11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c71a11",
  null
  
)

export default component.exports